import React from 'react';
import { withStyles, Theme, createStyles, LinearProgress, Card, CardHeader, Button } from "@material-ui/core";
import { withRouter, RouteComponentProps } from "react-router-dom";
import  {SelfTimingEvent, EventEntryList} from '../models/Event';
import {withTranslation, WithTranslation} from 'react-i18next';
import SelfTimingBackend from "../providers/SelfTimingBackend";
import moment from 'moment';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

interface Props {
    EntryList : EventEntryList;
    back : () => void;
    enter : () => void;
}

class EventEntries extends React.Component<Props & WithTranslation,any>
{
    render()
    {
        const {classes, t} = this.props as any;
        return <div><Button onClick={this.props.back} variant="contained" color="primary">Tillbaka</Button> <Button onClick={this.props.enter} variant="contained" color="primary">Anmäl dig</Button>
            {this.props.EntryList.map((classEntryList) => {
                return <Card style={{margin: '2px'}}>
                <CardHeader className={classes.cardHeader} style={{padding: '3px'}} 
                title={classEntryList.Class + ", " + classEntryList.Entries.length + " anmälda"}/>       
                <table style={{border:0, borderSpacing:0,borderCollapse:'collapse'}}>
                    <tr><th style={{textAlign:'left'}}>Namn</th><th style={{textAlign:'left'}}>Team</th><th style={{textAlign:'left'}}>TagNo</th></tr>
                    {classEntryList.Entries.map((entry,idx) => {
                        return <tr style={{background: idx%2 == 1? "#EFEFEF" : ""}}><td>{entry.FirstName + " " + entry.LastName}</td><td>{entry.Team}</td><td>{entry.TagNo}</td></tr>;
                    })}
                </table>
                </Card>
            })}
            </div>;

    }
}

const useStyles = ({ palette, spacing }: Theme) => createStyles({
  
    tableHeader: {
        backgroundColor: palette.primary.light,
        color: 'white'
    },
    formControl: {
        
        margin: '3px',
        minWidth: 200,
      },
      cardHeader: {
        backgroundColor: '#FFFFFF',
        color: '#000000'
      },
        cardHeaderTitle: {
            fontSize: '10px',
            lineHeight: '10px'
        }
  
});

export default withStyles(useStyles)(withTranslation()(EventEntries));